import script from "./CustomerMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerMenu.vue?vue&type=style&index=0&id=358cc6e1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358cc6e1"]])

export default __exports__